/*!
 * ATTENTION
 *
 * This module is used on both the main backlog app and its vendorless early-script entry.
 *
 * Because of this, it can't have dependencies. Feature-flagging logic should be done outside this
 * module and values should be passed in. For now changes must happen on both calls.
 */

export const backlogDataOperationName = 'BacklogDataQuery';

export const getQuery = () => `
    query ${backlogDataOperationName} ($boardId: ID!) {
        jira {
            timeTrackingOptions {
                workingHoursPerDay
                workingDaysPerWeek
                defaultUnit
                timeFormat
            }
        }
        boardScope(boardId: $boardId) {
            sprints(state:[ACTIVE, FUTURE]) {
                id
                name
                goal
                startDate
                endDate
                daysRemaining
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                sprintState
            }
            backlog {
                boardIssueListKey
                requestColumnMigration
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
            }
            board {
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                rankCustomFieldId
                issueParents {
                    id
                    key
                    summary
                    issueType {
                        id
                        name
                        iconUrl
                    }
                    color
                }
            }
            currentUser {
                permissions
            }
            projectLocation {
                id
                key
                name
                issueTypes {
                    id
                    name
                    iconUrl
                    hierarchyLevelType
                    hasRequiredFields
                } 
                features {
                    key
                    status
                }
            }
            features {
                key
                status
            }
            estimation {
                current {
                    customFieldId
                }
                available {
                    statisticFieldId
                }
            }
        }
    }
`;

export const getQueryIncludeChildIssues = () => `
    query ${backlogDataOperationName} ($boardId: ID!) {
        jira {
            timeTrackingOptions {
                workingHoursPerDay
                workingDaysPerWeek
                defaultUnit
                timeFormat
            }
        }
        boardScope(boardId: $boardId) {
            sprints(state:[ACTIVE, FUTURE]) {
                id
                name
                goal
                startDate
                endDate
                daysRemaining
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                sprintState      
                        issueChildren {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    priority {
                        name
                        iconUrl
                    }
                }
            }
            backlog {
                boardIssueListKey
                requestColumnMigration
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                issueChildren {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    priority {
                        name
                        iconUrl
                    }
                }
            }
            board {
                cards {
                    id
                    issue {
                        id
                        key
                        summary
                        labels
                        type {
                            id
                            name
                            iconUrl
                        }
                        status {
                            id
                            name
                            category
                        }
                        assignee {
                            accountId
                            displayName
                            avatarUrl
                        }
                    }
                    flagged
                    done
                    parentId
                    estimate {
                        storyPoints
                        originalEstimate {
                            value
                            valueAsText
                        }
                    }
                    priority {
                        name
                        iconUrl
                    }
                    dueDate
                    childIssuesMetadata {
                        complete
                        total
                    }
                    fixVersions
                }
                rankCustomFieldId
                issueParents {
                    id
                    key
                    summary
                    issueType {
                        id
                        name
                        iconUrl
                    }
                    color
                }
            }
            currentUser {
                permissions
            }
            projectLocation {
                id
                key
                name
                issueTypes {
                    id
                    name
                    iconUrl
                    hierarchyLevelType
                    hasRequiredFields
                } 
                features {
                    key
                    status
                }
            }
            features {
                key
                status
            }
            estimation {
                current {
                    customFieldId
                }
                available {
                    statisticFieldId
                }
            }
        }
    }
`;
